export default [
    {
        path: "accounting-accounts",
        name: "bookeeping-accounting-accounts",
        redirect: { name: "bookeeping-accounting-accounts-list" },
        component: () => import("@/views/commons/accounting-accounts/AccountingAccounts.vue"),
        meta: {
            section: 36,
            breadcrumb: [
                {
                    text: "Accounting accounts"
                },
            ],
            tabs: [
                {
                    title: "Accounts",
                    name: "bookeeping-accounting-accounts-list",
                },
                {
                    title: "Transaction types",
                    name: "bookeeping-accounting-accounts-transaction-types",
                },
            ],
        },
        children: [
            {
                path: "list",
                name: "bookeeping-accounting-accounts-list",
                component: () =>
                    import("@/views/commons/accounting-accounts/components/AccountingAccountsTable.vue"),
                meta: {
                    section: 36,
                    tab: "pending",
                    pageTitle: "Accounting accounts",
                    breadcrumb: [
                        {
                            text: "Accounts",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "transaction-types",
                name: "bookeeping-accounting-accounts-transaction-types",
                component: () =>
                    import("@/views/commons/accounting-accounts/components/TransactionTypesTable.vue"),
                meta: {
                    section: 36,
                    tab: "approved",
                    pageTitle: "Accounting accounts",
                    breadcrumb: [
                        {
                            text: "Transaction types",
                            active: true,
                        },
                    ],
                },
            },
        ],
    }
]